import { StripeError } from "@stripe/stripe-js";
import { useState } from "react";
import { MessageDescriptor } from "react-intl";
import messages from "./messages";

const stripeErrorsMapping = {
  generic_decline: messages.genericDecline,
  insufficient_funds: messages.insufficientFunds,
  lost_card: messages.lostCard,
  stolen_card: messages.stolenCard,
  expired_card: messages.expiredCard,
  incorrect_cvc: messages.CVC,
  processing_error: messages.processingError,
  incorrect_number: messages.incorrectNumber,
  invalid_number: messages.incorrectNumber,
  invalid_expiry_year_past: messages.expiredCard,
  invalid_expiry_month_past: messages.expiredCard,
  incomplete_number: messages.incompleteNumber,
  incomplete_cvc: messages.incompleteCVC,
  incomplete_expiry: messages.incompleteExpiry,
};

export const useStripeError = () => {
  const [stripeError, setStripeErrorHook] = useState<
    MessageDescriptor | undefined
  >(undefined);

  const mapErrorMessage = (stripeError: StripeError) => {
    if (stripeError === undefined) return undefined;
    return stripeError.decline_code ?? stripeError.code;
  };

  const setStripeError = (error: StripeError | undefined) => {
    if (error === undefined) {
      setStripeErrorHook(undefined);
    } else {
      const message = mapErrorMessage(error);
      setStripeErrorHook(
        stripeErrorsMapping[message] ?? messages.genericDecline
      );
    }
  };

  return {
    stripeError,
    setStripeError,
  };
};
